import hostname from "../api/config.host";
import { fetchWrapper } from "../api/fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

interface QueriesInFetcherSettingsParams {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[]; // Multiple
  // dimension: string[];
  level?: string;
  item_id?: string;
  brand_id?: string;
}

function getFetcherSettingsData(params: QueriesInFetcherSettingsParams) {
  const {
    oauthTokenHeader,
    queryId,
    websiteSharedUids = [],
    // dimension = [],
    level,
    item_id,
    brand_id,
  } = params;
  const searchParams = new URLSearchParams();
  if (level) {
    searchParams.append("level", level);
  }
  if (item_id) {
    searchParams.append("item_id", item_id);
  }
  if (brand_id) {
    searchParams.append("brand_id", brand_id);
  }
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  //   const requestBody = {
  //     website_shared_uid: websiteSharedUids,
  //     dimension,
  //   };
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

export const fetcherSettingsService = {
  getFetcherSettingsData,
};
